<template>
  <div class="standardCreation">
    <div class="standardCreation_titleArea">
      <div class="titleArea_inputBox">
        <input
          v-model="adgroup_name"
          class="input"
          @input="inputvalue"
        >
        <i class="el-icon-edit" />
      </div>
      <div class="titleArea_buttonBox">
        <ul class="buttonBox_ul">
          <li class="ul_item">
            <i class="el-icon-plus" />
            <span class="item_text">添加商品</span>
          </li>
          <li class="ul_item">
            <i class="el-icon-plus" />
            <span class="item_text">添加门店</span>
          </li>
          <li class="ul_item">
            <span class="item_text">收起广告</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="standardCreation_main">
      <div class="main_left">
        <LaunchTime
          :start-time="currentIfon.begin_date"
          :end-time="currentIfon.end_date"
          :time_series="currentIfon.time_series"
          :radioone="radioone"
          :radiotwo="radiotwo"
          :campaign="campaign"
          @setLaunchTime="$emit('setLaunchTime',$event)"
          @setLaunchtimeall="$emit('setLaunchtimeall',$event)"
          @setLaunchoose="$emit('setLaunchoose',$event)"
          @setLaunchooseone="$emit('setLaunchooseone',$event)"
        />
        <Attribution :tracking_sourceid="tracking_sourceid" :zhuanhuaname="zhuanhuaname" @dataidsrempty="$emit('dataidsrempty',$event)" @dataidsr="$emit('dataidsr',$event)" @dataname="$emit('dataname',$event)" />
        <BiddingMethod
          :strategy_opt="strategy_opt"
          :bid_strategy="bid_strategy"
          :objall="objall"
          @bendistrategyopt="$emit('bendistrategyopt',$event)"
          @toufangset="$emit('toufangset',$event)"
        />
        <!-- :gender1="currentIfon.targeting.gender[0]" -->
        <TargetedPopulation
          :gender1="currentIfon.targeting.gender[0]"
          :education="currentIfon.targeting.education"
          :user_os="currentIfon.targeting.user_os"
          :device_price="currentIfon.targeting.device_price"
          :start-age1="currentIfon.targeting.age[0].min"
          :end-age1="currentIfon.targeting.age[0].max"
          :region1="currentIfon.targeting.geo_location.location_types[0]"
          :ad_target="ad_target"
          @setTargetedPopulation="$emit('setTargetedPopulation',$event)"
          @Targetedpopulation="$emit('Targetedpopulation',$event)"
        />
        <BudgetExpenditure
          :budget1="currentIfon.bid_amount"
          :offer1="currentIfon.daily_budget"
          :budget="budget"
          :bid="bid"
          @budgetext="$emit('budgetext',$event)"
          @offertext="$emit('offertext',$event)"
        />
        <div class="left_button">
          <el-button @click="$emit('previousStep')">上一步</el-button>
          <el-button
            type="success"
            @click="$emit('nextStep')"
          >下一步</el-button>
        </div>
      </div>
      <div class="main_right" />
    </div>
  </div>
</template>

<script>
import LaunchTime from './components/LaunchTime.vue'
import Attribution from './components/attribution.vue'
import BiddingMethod from './components/BiddingMethod.vue'
import TargetedPopulation from './components/TargetedPopulation.vue'
import BudgetExpenditure from './components/BudgetExpenditure.vue'
export default {
  components: {
    LaunchTime,
    Attribution,
    BiddingMethod,
    TargetedPopulation,
    BudgetExpenditure
  },
  props: {
    currentIfon: {},
    radioone: {},
    radiotwo: {},
    campaign: {},
    strategy_opt: {},
    bid_strategy: {},
    ad_target: {},
    budget: {},
    bid: {},
    objall: {},
    aname: {},
    tracking_sourceid: {},
    zhuanhuaname: {}
  },
  data() {
    return {
      adgroup_name: ''
    }
  },
  created() {
    this.adgroup_name = this.aname
    // this.adgroup_name = this.currentIfon.adgroup_name
    // console.log(this.currentIfon)
  },
  methods: {
    inputvalue(val) {
      this.$emit('setinputvalueaname', this.adgroup_name)
      // console.log('value', this.adgroup_name)
    }
  }
}
</script>

<style scoped lang="less">
.standardCreation {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  padding-bottom: 100px;
  .standardCreation_titleArea {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .titleArea_inputBox {
      .input {
        height: 30px;
        background-color: transparent;
        outline: none;
        margin-right: 10px;
        border: 1px solid transparent;
        border-radius: 5px;
        padding-left: 5px;
        font-size: 16px;
        font-weight: bold;
        &:hover {
          border: 1px solid black;
        }
      }
    }

    .titleArea_buttonBox {
      .buttonBox_ul {
        display: flex;

        .ul_item {
          padding: 8px;
          cursor: pointer;
          border-radius: 3px;
          background-color: transparent;
          transition: background-color 0.5s;
          &:hover {
            background-color: rgba(100, 100, 100, 0.2);
          }
          .item_text {
            display: inline-block;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .standardCreation_main {
    display: flex;
    width: 100%;
    .main_left {
      width: 70%;

      .left_button {
        display: flex;
        justify-content: space-between;
      }
    }
    .main_right {
      flex-grow: 1;
    }
  }
}
</style>
